import type { NoteAudience } from "@shyne/shared/api";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { INTERNAL_NOTE_HINT, NOTE_AUDIENCE_OPTIONS } from "@/repositories/appointment-history";

interface NoteAudiencePickerProps {
  audience: NoteAudience[];
  onChange: (audience: NoteAudience[]) => void;
  idPrefix?: string;
}

export default function NoteAudiencePicker({ audience, onChange, idPrefix = "note-audience" }: NoteAudiencePickerProps) {
  const toggle = (id: NoteAudience) => onChange(audience.includes(id) ? audience.filter((chosen) => chosen !== id) : [...audience, id]);

  return (
    <div className="space-y-1.5">
      <p className="text-xs font-medium text-muted-foreground">{INTERNAL_NOTE_HINT}</p>
      <div className="flex items-center gap-4">
        {NOTE_AUDIENCE_OPTIONS.map((option) => (
          <div key={option.id} className="flex items-center gap-1.5">
            <Checkbox id={`${idPrefix}-${option.id}`} checked={audience.includes(option.id)} onCheckedChange={() => toggle(option.id)} />
            <Label htmlFor={`${idPrefix}-${option.id}`} className="text-xs cursor-pointer">
              {option.label}
            </Label>
          </div>
        ))}
      </div>
    </div>
  );
}
